import AdminPageHeader from '../../components/admin/AdminPageHeader';
import React from 'react';
import { ChevronRight, Home, ShieldCheck } from 'lucide-react';
import LogSecurityList from '../../components/LogSecurity/LogSecurityList';

const css = `

.logs-page, .logs-page * { box-sizing: border-box; }
.logs-page { font-family: 'DM Sans', sans-serif; }
@keyframes logsFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
.logs-page__header { animation: logsFadeUp .45s cubic-bezier(.16,1,.3,1) both; }
.logs-page__content { animation: logsFadeUp .45s .07s cubic-bezier(.16,1,.3,1) both; }
`;

const LogsSecurityPage: React.FC = () => (
    <>
        <style>{css}</style>
        <main className="logs-page" style={{ background: 'var(--ad-surface, #fff)', minHeight: '100vh', padding: 'clamp(24px,3vw,36px) clamp(16px,4vw,40px)' }} data-admin-page="true">
            <div style={{ maxWidth: 1480, margin: '0 auto' }}>
                <AdminPageHeader eyebrow="SISTEMA / CO MARCA GROUP" title="Seguridad" description="Revisa accesos, intentos y eventos sensibles registrados."/>
                <section className="logs-page__content" aria-label="Registros de seguridad"><LogSecurityList /></section>
            </div>
        </main>
    </>
);

export default LogsSecurityPage;


